import React, { useEffect, useState } from 'react'
import { Avatar, Card, Col, Pagination, Row, Tooltip } from 'antd'
import { useNavigate } from 'react-router-dom'
import Button from '../../../../components/FormElements/Button'
import { useDispatch, useSelector } from 'react-redux'
import useQuoteApi from '../../../../config/hooks/api/booking/quote/useQuoteApi'
import { setAppLoading } from '../../../../store/common/generalSlice'
import { getEllipsedString, getInitials, getServicesList } from '../../../../config/utils'
import { finalPriceAfterExtractingCommission } from '../../../../config/utils/finalPriceExtractingCommission'
import { calculateCommission } from '../../../../config/utils/calculateCommission'

const PriceProposals = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { getMySentQuotes } = useQuoteApi()
    const { profileData } = useSelector(state => state?.setting);


    const [priceProposals, setPriceProposals] = useState([])
    const [offset, setOffset] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0)

    // const spProfileData = useSelector(state => state?.setting?.profileData)

    const getPriceProposals = async () => {
        try {
            dispatch(setAppLoading(true))

            const response = await getMySentQuotes(pageSize, offset)
            if (response) {
                setPriceProposals(response?.data?.quote?.rows)

                setTotalItems(response?.data?.quote?.count)
                setOffset(offset + pageSize)

                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const onShowSizeChange = (current, pageSize) => {
        setPageSize(pageSize)
    };

    const onPageChange = (page) => {
        setCurrentPage(page);
        setOffset((page - 1) * pageSize)
    };

    useEffect(() => {
        getPriceProposals()
    }, [currentPage, pageSize])

    return (
        <Row>
            <Col span={24}>
                {
                    priceProposals && priceProposals.length ?
                        priceProposals.map((proposal, idx) => {
                            let servicesLength = proposal?.services?.length || 0;
                            return (
                                <Card
                                    bordered={false}
                                    className='mb-4 rounded-md'
                                    key={'proposal' + idx}
                                >
                                    <div className='flex sm:flex-row flex-col justify-between'>
                                        <div className='flex sm:flex-row flex-col sm:mb-1 mb-4'>
                                            <div className='flex sm:flex-row flex-col mb-2 items-center'>
                                                <span className='border-2 p-1 mb-2 border-primary rounded-full'>
                                                    <Avatar src={proposal?.booking?.serviceUser?.imageThumbUrl} className='img-fluid w-[100px] h-[100px]'>
                                                        {getInitials(proposal?.booking?.serviceUser?.fullName)}
                                                    </Avatar>
                                                </span>
                                            </div>
                                            <div className='flex flex-col sm:ml-4'>
                                                <div className='sm:mb-4 mb-2 ml-1'>
                                                    <div className='flex justify-center sm:justify-start'>
                                                        <h3 className='heading-3 font-bold mb-2 whitespace-nowrap'>
                                                            {getEllipsedString(proposal?.booking?.serviceUser?.fullName, 15)}
                                                        </h3>
                                                        {/* { user?.badge && (
                                                <img src={proposal?.user?.badge} alt='badge' className='img-fluid ml-2 h-[30px]' />
                                                ) } */}

                                                        {
                                                            proposal?.user?.badges &&
                                                                proposal?.user?.badges.length ? (
                                                                <div className='ml-2 flex items-center sm:w-[50px]'>
                                                                    {proposal?.user?.badges.map(badge => (
                                                                        <img
                                                                            key={badge?.id}
                                                                            src={badge?.imageUrl}
                                                                            alt={badge?.name}
                                                                            className='img-fluid mr-2 h-[30px]'
                                                                            onError={(e) => { e.target.style.display = 'none' }}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )
                                                                : ''}
                                                    </div>
                                                    {/* previous work */}
                                                    {/* <div className='flex justify-center sm:justify-start'>
                                                    {
                                                        proposal?.services &&
                                                            proposal?.services.length ? (
                                                            <React.Fragment>
                                                                {proposal?.services.slice(0, 3).map((service, index) => (
                                                                    <span key={service?.id}>
                                                                        <p className='text-gray-500 font-semibold text-xs mb-2' >
                                                                            {service?.name}

                                                                            {index < proposal?.services.slice(0, 3).length - 1 &&
                                                                                (<span className='mx-1'>|</span>)}
                                                                            {index == 2 && proposal?.services.length > 3 ?
                                                                                (<span className='mr-1'>...</span>) : ''}
                                                                        </p>
                                                                    </span>
                                                                ))}
                                                                {proposal?.services?.length > 3 ? (
                                                                    <Tooltip title={getServicesList(proposal?.services)}>
                                                                        <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                    </Tooltip>
                                                                ) : ''}
                                                            </React.Fragment>
                                                        )
                                                            : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )}
                                                </div> */}

                                                    {/* updated work */}
                                                    {/* <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            proposal?.selectedCategories &&
                                                                proposal?.selectedCategories?.length > 0 ? (
                                                                <React.Fragment>
                                                                    {
                                                                        proposal?.selectedCategories[0].subServices?.length > 0 ?
                                                                            <span className='flex gap-1 items-center'>
                                                                                <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                    {proposal?.selectedCategories[0].name + ','}
                                                                                </p>
                                                                                <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                    {proposal?.selectedCategories[0].subServices[0]?.name + ' ...'}                                                                            </p>
                                                                            </span>
                                                                            :
                                                                            <p>-</p>

                                                                    }
                                                                    {proposal?.selectedCategories?.length > 0 &&
                                                                        proposal?.selectedCategories[0]?.subServices?.length > 0 &&
                                                                        proposal?.selectedCategories[0]?.subServices[0]?.subServices?.length > 0
                                                                        ? (
                                                                            <Tooltip title={getServicesList(proposal?.selectedCategories[0]?.subServices[0]?.subServices, true)}>
                                                                                <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                            </Tooltip>
                                                                        ) : ''}
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )
                                                        }
                                                    </div> */}

                                                    <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            proposal?.services &&
                                                                servicesLength > 0 ? (
                                                                <React.Fragment>
                                                                    {
                                                                        proposal?.services?.slice(0, 3)?.map((service) => {
                                                                            return (
                                                                                <span className='flex gap-1 items-center' key={service?.id}>
                                                                                    <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                        {service?.name + ','}
                                                                                    </p>
                                                                                </span>
                                                                            )
                                                                        })
                                                                    }
                                                                    {servicesLength > 4 && <span>...</span>}
                                                                    {servicesLength > 4 &&
                                                                        (
                                                                            <Tooltip title={getServicesList(proposal?.services, false)}>
                                                                                <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                            </Tooltip>
                                                                        )
                                                                    }
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )
                                                        }
                                                    </div>

                                                    <p className='text-xs sm:text-left text-center'>{proposal?.additionalInfo}</p>
                                                </div>
                                                <div className='flex sm:justify-start justify-center'>
                                                    <Button.Basic
                                                        type="primary"
                                                        size={"small"}
                                                        text={'Job Details'}
                                                        onClick={() => navigate(`/quote/${proposal?.id}/price-proposal`)}
                                                        disabled={false}
                                                        className='h-[40px] text-xs rounded-md'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex flex-col items-end'>
                                            <small className='text-xs text-[#FF1D6A] inline-block mb-4'>
                                                {`${Math.round(proposal?.distance) > 0 ?
                                                    proposal?.distance.toFixed(2) :
                                                    0
                                                    } Miles Away`}
                                            </small>
                                            <div className='flex flex-col gap-4 items-end'>
                                                <div className='flex items-center gap-2'>
                                                    <span className='text-red-500'>Quoted Price: </span>
                                                    <h2 className='heading-2 text-base text-red-500 mt-1'>£{proposal?.price}</h2>
                                                </div>
                                                <div className='flex items-center gap-2'>
                                                    <span>Final Earnings:</span>
                                                    {
                                                        profileData?.userDetail?.isEnabled ?
                                                            <p className='text-start heading-2 text-3xl font-bold'>£{finalPriceAfterExtractingCommission(proposal?.price, profileData?.userDetail?.percentage)}</p>
                                                            :
                                                            <p className='text-start heading-2 text-3xl font-bold'>£{finalPriceAfterExtractingCommission(proposal?.price, calculateCommission(proposal?.services))?.toFixed(2)}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            )
                        }) : "Price proposals not available"
                }
            </Col>

            {
                totalItems ? (
                    <Col span={24}>
                        <div className='px-2 py-4 bg-white rounded-md'>
                            <Pagination
                                defaultPageSize={5}
                                showSizeChanger
                                onShowSizeChange={onShowSizeChange}
                                current={currentPage}
                                total={totalItems}
                                pageSize={pageSize}
                                pageSizeOptions={[5, 10, 20, 50]}
                                onChange={onPageChange}
                            />
                        </div>
                    </Col>
                ) : null
            }
        </Row >
    )
}

export default PriceProposals